import React                  from 'react';
import PropTypes              from 'prop-types';
import Translations           from '../../../utils/Translations';
import ActorPin               from '../../Favorite/Actor/Pin';
import VideochatButton        from '../../SimpleElements/VideochatButton';
import Flux                   from '../../../flux/Flux';
import {VXPay}                from '../../../utils/VXPay';
import {getCommonTranslation} from '../../../utils/TranslationHelper';
import VideochatButtonWrapper from '../../SimpleElements/VideochatButtonWrapper';

class ActorPlateExtended extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onStartTextChat = this.onStartTextChat.bind(this);
    }

    onStartTextChat(e) {
        if (Flux.Guest.isLoggedIn()) {
            Flux.Messenger.selectChannelByActorId(this.props.actorId, true);
        } else {
            if (Flux.Guest.isAnonymousVoicecall()) {
                VXPay.openSignup({
                    host:  this.props.actorId,
                    texts: {
                        BonusTextCustom: Translations.get('VoicecallVXPayTeasserText'),
                    },
                });
            } else {
                VXPay.openSignupOrLogin();
            }
        }
        if ((typeof e === 'object') && e.cancelable) {
            e.stopPropagation();
            e.preventDefault();
        }
        return false;
    }

    render() {
        return (
                <div className="actor-plate actor-plate--extended">
                    <div className="actor-plate__actor">
                        <h3 className="actor-plate__name">{this.props.name}</h3>
                        <div className="actor-plate__age">({this.props.age})</div>
                        {Flux.Guest.isLoggedIn() && <div className="actor-plate__favorite">
                            <ActorPin actorId={this.props.actorId}
                                      initialIsFavoriteOfGuest={this.props.isModelGuestFavorite}
                                      fontSize="-size-sm"
                            />
                        </div>}
                        <ul className="actor-plate__lang-wrapper">
                            {this.props.spokenLanguages && this.props.spokenLanguages.map(lang =>
                                    <li key={'lang-' + lang.toLowerCase()} className="actor-plate__lang">
                                        <span className={"badge-language -lang-" + lang.toLowerCase()}> </span>
                                    </li>
                            )}
                        </ul>
                    </div>
                    <div className="actor-plate__button-wrapper">
                        <div className="actor-plate__button">
                            {this.props.isOnline || (this.props.isOnlineMobileVideocall && !Flux.Guest.isVoicecallActive()) ?
                                    <VideochatButtonWrapper actorId={this.props.actorId} type={Flux.Constants.VideochatButtonTypes.actorPlateVideochat} /> :
                                    <button onClick={this.onStartTextChat}
                                            className="btn--icon-detailed -icon-chat-text-full -click-material h-width-full"
                                    >
                                        <span className="ink animate" />
                                        {Translations.get('ActorGridMessageText')}
                                        <span className="btn--icon-detailed__teaser">{Translations.get('ActorGridWriteFreeText')}</span>
                                    </button>
                            }
                        </div>
                    </div>
                </div>
        );
    }
}

ActorPlateExtended.propTypes = {
    actorId:                 PropTypes.number.isRequired,
    name:                    PropTypes.string.isRequired,
    age:                     PropTypes.number.isRequired,
    isOnline:                PropTypes.bool.isRequired,
    spokenLanguages:         PropTypes.array.isRequired,
    multiChatPrice:          PropTypes.number.isRequired,
    singleC2CChatPrice:      PropTypes.number,
    guestIsLoggedIn:         PropTypes.bool.isRequired,
    isModelGuestFavorite:    PropTypes.bool.isRequired,
    freeChat:                PropTypes.object,
    isBannedCountryCode:     PropTypes.bool,
    actorLink:               PropTypes.string,
    isCurrentlyTicketShow:   PropTypes.bool,
    guestHasTicket:          PropTypes.bool,
    isMobile:                PropTypes.bool,
    gaString:                PropTypes.string,
    isOnlineMobileVideocall: PropTypes.bool,
};

ActorPlateExtended.defaultProps = {
    isOnlineMobileVideocall: false,
};

export default ActorPlateExtended;
